import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import makeRequest from 'utils/makeRequest';
import classNames from 'classnames';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import CardList from 'components_v2/common/CardListV5/CardListV5';
import RenderAds from 'routes/home/components/desktop/RenderAds';
import _get from 'lodash.get';
import s from './SixColumnLayout.scss';
import Card from '../../common/CardV2';

import Listingheader from '../../../routes/home/components/common/ListingheaderV2';
import InterSectionBorder from '../../common/InterSectionBorder/InterSectionBorder';

class SixColumnLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sectionData: props.sectionData,
    };
  }

  loadCurrentSection = () => {
    const { sectionData } = this.props;
    if (typeof sectionData.dataUrl === 'string') {
      this.loadSectionData(sectionData.dataUrl);
    }
  };

  loadSectionData = dataUrl => {
    if (!dataUrl) {
      return;
    }

    makeRequest
      .get(dataUrl, { isMobile: this.props.isMobile }, 'skipfeedengine')
      .then(data => {
        if (data && data.data) {
          const sectionData = {};
          sectionData.items = data.data.items ? data.data.items : data.data;
          this.setState({
            sectionData,
          });
        }
      });
  };

  render() {
    const {
      sectionData,
      gridRequired,
      oneByOneCard = { items: [] },
      subSection,
      wrapperClass,
      gaCategory,
      setGaCategory,
    } = this.props;

    const containerClass = classNames({
      [wrapperClass]: wrapperClass,
      [s.subsection_spacing]: subSection,
    });
    const items = sectionData.items || this.state.sectionData.items;
    const itemsList = items || [];
    const scrollGAAttr = {
      ...(sectionData.onScrollGA &&
        sectionData.id && { 'data-scrollga': sectionData.id }),
    };

    return (
      <InViewObserver
        inViewCallback={() => {
          this.loadCurrentSection();
        }}
        viewMargin="500px 0px 500px 0px"
      >
        {itemsList &&
          itemsList instanceof Array &&
          itemsList.length > 0 && (
            <div
              className={`${s.six_col_layout} ${containerClass}`}
              {...scrollGAAttr}
            >
              {sectionData.border &&
                sectionData.border === 'top' && (
                  <InterSectionBorder border={sectionData.border} />
                )}
              <Listingheader
                headingname={sectionData.name}
                headingLink={sectionData.link || sectionData.path}
                subheading={sectionData.subHeading}
                size={this.props.size}
                ga4DataHeading={sectionData.ga4DataHeading}
                newga={
                  gaCategory
                    ? `${gaCategory}#Click#${sectionData.link ||
                        sectionData.path}`
                    : `${sectionData.name}Section_Actions#HeadingClick`
                }
                target={sectionData.target}
                newgaSetCategory={setGaCategory}
                ga4Type={sectionData?.ga4Type}
                ga4Category={sectionData?.ga4Category}
              />
              <div
                className={`${s.featured_today} ${
                  gridRequired === '0' ? s.nonGrid : 'grid_wrapper'
                } `}
              >
                {itemsList instanceof Array &&
                  itemsList.map((col, index) => {
                    const spotlightGA =
                      col.ag && col.ag === 'spotlight'
                        ? `sl_${index + 1}_${col.id}`
                        : null;
                    return (
                      <React.Fragment key={col.id || col.name}>
                        {!(col.items && col.items instanceof Array) && (
                          <div
                            className={
                              gridRequired === '0' ? s.cards : 'col_l_2 col_m_4'
                            }
                          >
                            <div>{col.name}</div>
                            {col.tn === 'ad' ? (
                              <div className="">
                                <RenderAds adObject={col} />
                              </div>
                            ) : (
                              <Card
                                data={col}
                                isVerticalTile
                                cssObj={{
                                  imgCont: oneByOneCard,
                                }}
                                newga={`${_get(
                                  col,
                                  'name',
                                  sectionData.name || sectionData.gaAction,
                                )}_Actions#$typeClick/${index}/${col.wu}`}
                                newgaSetCategory={setGaCategory}
                                imgWidth="200"
                                viewga={spotlightGA}
                                target={sectionData.target}
                                ga4Type={
                                  col?.ga4Type
                                    ? col?.ga4Type
                                    : sectionData?.ga4Type
                                }
                                ga4Category={
                                  col?.ga4Category
                                    ? col?.ga4Category
                                    : sectionData?.ga4Category
                                }
                                gaIndex={index + 1}
                              />
                            )}
                          </div>
                        )}
                      </React.Fragment>
                    );
                  })}
              </div>

              <div className={`${'grid_wrapper'}`}>
                {itemsList instanceof Array &&
                  itemsList.map(col => (
                    <React.Fragment key={col.id || col.name}>
                      {(col.data || col.items) &&
                        (col.data || col.items) instanceof Array && (
                          <div className={`${'col_l_2 col_m_4'}`}>
                            {col.name && (
                              <Listingheader
                                headingname={col.name}
                                headingLink={col.link || col.path}
                                subheading={sectionData.subHeading}
                                size="small"
                                newga={`${
                                  sectionData.name
                                }Section_Actions#HeadingClick-${col.name}`}
                                target={col.target}
                                newgaSetCategory={setGaCategory}
                                ga4Type={
                                  col?.ga4Type
                                    ? col?.ga4Type
                                    : sectionData?.ga4Type
                                }
                                ga4Category={
                                  col?.ga4Category
                                    ? col?.ga4Category
                                    : sectionData?.ga4Category
                                }
                                overrideClass={col.className || ''}
                              />
                            )}
                            {(col.data || col.items) && (
                              <CardList
                                imgFit={col.imgFit}
                                data={col.data || col.items}
                                featuredItemDisplay={{
                                  cssObj: {
                                    figureClass: s.leadplusText,
                                    titleCont: s.fontBold,
                                  },
                                  featuredIndex: 0,
                                  isVerticalTile: true,
                                }}
                                nonFeaturedDisplay={{
                                  tileType: 'default',
                                  itemWrapperClass: 'bdr_bottom no_bdr_last',
                                  itemClass: 'linktype2 mrgTB10',
                                  hideImage: true,
                                }}
                                showDescription={false}
                                newga={`${col.name}_Actions#$typeClick-/`}
                                newgaSetCategory={setGaCategory}
                                htmlKeys={col.htmlKeys}
                                imgWidth="200"
                                ga4Type={
                                  col?.ga4Type
                                    ? col?.ga4Type
                                    : sectionData?.ga4Type
                                }
                                ga4Category={
                                  col?.ga4Category
                                    ? col?.ga4Category
                                    : sectionData?.ga4Category
                                }
                              />
                            )}
                          </div>
                        )}
                    </React.Fragment>
                  ))}
              </div>
              {sectionData.border &&
                sectionData.border === 'bottom' && (
                  <InterSectionBorder border={sectionData.border} />
                )}
            </div>
          )}
      </InViewObserver>
    );
  }
}

const mapStateToProps = state => ({
  isMobile: state.isMobile,
});

SixColumnLayout.propTypes = {
  sectionData: PropTypes.shape({}).isRequired,
  gridRequired: PropTypes.string,
  oneByOneCard: PropTypes.string,
  isMobile: PropTypes.bool,
  ga4Category: PropTypes.string,
  ga4Type: PropTypes.string,
};

SixColumnLayout.defaultProps = {
  gridRequired: '',
  oneByOneCard: '',
  isMobile: false,
  ga4Category: '',
  ga4Type: '',
};

export default connect(mapStateToProps)(SixColumnLayout);
